"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeStream = void 0;
var TypeStream;

(function (TypeStream) {
  /**
   * 스트림을 Subscribe 해요
   */
  TypeStream["ReqStreamSubscribe"] = "REQ.STREAM.SUBSCRIBE";
  /**
   * 스트림에 이벤트를 Emit 해요
   * @required eventName  이벤트 이름
   * @optional data       담을 데이터 (JSON String)
   * @optional target     이벤트를 전달할 대상 `allowlist`(default), `all`
   */

  TypeStream["ReqStreamEmit"] = "REQ.STREAM.EMIT";
  /**
   * 다른 웹뷰 또는 자기 자신이 Emit한 이벤트를
   * 다음 메시지 타입으로 받아요
   * @required eventName  이벤트 이름
   * @optional data       담을 데이터 (JSON String)
   */

  TypeStream["ResStreamEvent"] = "RES.STREAM.EVENT";
})(TypeStream = exports.TypeStream || (exports.TypeStream = {}));